import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    const menu = document.getElementById("portfolio-mobile-menu")
    if (!menu) return

    const previewMenu = this.element.dataset.previewMenu === "true"
    const isOpen = !menu.classList.contains("is-open")

    if (!previewMenu) {
      menu.classList.toggle("hidden")
      menu.classList.toggle("is-open", isOpen)
      this.element.classList.toggle("is-open", isOpen)
      this.element.setAttribute("aria-expanded", String(isOpen))
      this.notifyParent(isOpen, false)
      return
    }

    this.element.classList.toggle("is-open", isOpen)
    this.element.setAttribute("aria-expanded", String(isOpen))
    menu.classList.toggle("hidden", !isOpen)
    menu.classList.toggle("is-open", isOpen)
    this.notifyParent(isOpen, false)
  }

  notifyParent(isOpen, lockScroll) {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage({
        type: "barokit:header-preview-menu-toggle",
        open: isOpen,
        height: document.body ? document.body.scrollHeight : null
      }, window.location.origin)
    }

    if (lockScroll) {
      document.documentElement.style.overflow = isOpen ? "hidden" : ""
      document.body.style.overflow = isOpen ? "hidden" : ""
    }
  }
}
